import React from "react";
import ReactDom from "react-dom";
import { RaisedButton, CircularProgress } from "material-ui";
import BaseOverlay from "./base.jsx";
import moment from "moment";

import EventFetcher from "../../utils/EventFetcher";
import PersonStore from "../../stores/PersonStore";

class VirtualPlayerOverlay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetchedVirtualScreeningId: null,
      virtualEvent: null,
      showConfirmWatchNow: false,
      embedSrc: null
    };

    this.start = this.start.bind(this);

    this._listener = this._listener.bind(this);
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      router: React.PropTypes.object.isRequired
    };
  }

  componentWillReceiveProps(props) {
    const id = props.params.virtualScreeningId;
    if (this.state.fetchedVirtualScreeningId !== id) {
      this.setState({ fetchedVirtualScreeningId: id });
      EventFetcher.fetchOneVirtual(PersonStore.getState().token, id)
        .then(data => {
          let showConfirmWatchNow = !data.person.available_ticket.expires_at;
          this.setState(
            {
              virtualEvent: data,
              showConfirmWatchNow
            },
            () => {
              if (!showConfirmWatchNow) {
                this.start();
              }
            }
          );
        })
        .catch(e => {
          console.error(e);
          window.alert(`Failed to load player: ${e.message}`);
          this.context.router.goBack();
        });
    }
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this._listener);

    // Remove the iframe from the DOM
    const el = document.getElementById("eventive-virtual-player-root");
    if (el) {
      ReactDom.unmountComponentAtNode(el);
    }
  }

  _listener() {
    if (this.state.embedSrc.indexOf(event.origin) !== 0) {
      return;
    }
    if (event.data.event === "eventive_player_dismiss") {
      this.context.router.goBack();
    }
  }

  renderPlayer() {
    if (!document.getElementById("eventive-virtual-player-root")) {
      const el = document.createElement("div");
      el.id = "eventive-virtual-player-root";
      document.body.appendChild(el);
    }

    ReactDom.render(
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 999999,
          background: "#000"
        }}
        // Note: have to dangerously set since React 15 doesn't support allow attribute, which
        // is required in order to allow DRM encrypted media playback.
        dangerouslySetInnerHTML={{
          __html: `
          <iframe
            src="${this.state.embedSrc}"
            style="width: 100%; height: 100%"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        `
        }}
      ></div>,
      document.getElementById("eventive-virtual-player-root")
    );
  }

  start() {
    this.setState({ showConfirmWatchNow: false });
    EventFetcher.playVirtualEvent(
      PersonStore.getState().token,
      this.state.virtualEvent.person.available_ticket.id
    )
      .then(data => {
        this.setState({ embedSrc: data.embed_src }, () => {
          this.renderPlayer();
        });
        window.addEventListener("message", this._listener);
      })
      .catch(e => {
        console.error(e);
        window.alert(`Failed to start session: ${e.message}`);
        this.context.router.goBack();
      });
  }

  render() {
    const { showConfirmWatchNow, embedSrc, virtualEvent } = this.state;

    if (showConfirmWatchNow && virtualEvent) {
      return (
        <BaseOverlay onRequestClose={() => this.context.router.goBack()}>
          <div style={{ textAlign: "center", fontSize: "11pt" }}>
            <h2>Are you sure?</h2>
            <p>
              Once you click "Watch now" below, you'll have{" "}
              <span style={{ fontWeight: "bold" }}>
                {Math.floor(virtualEvent.watch_interval / (1000 * 60 * 60))}{" "}
                hours
              </span>{" "}
              to finish the program before it expires.
            </p>
            <p>
              <RaisedButton
                onClick={() => this.start()}
                primary
                label="Watch now"
              />
            </p>
            <p>
              Not ready yet? You have until{" "}
              {moment(
                virtualEvent.person.available_ticket.unlocked_until
              ).format("LLLL")}{" "}
              to start watching.
            </p>
          </div>
        </BaseOverlay>
      );
    }

    if (embedSrc) {
      return null;
    }

    return (
      <BaseOverlay onRequestClose={() => this.context.router.goBack()}>
        <div>
          <CircularProgress
            mode="indeterminate"
            size={119}
            thickness={7}
            style={{ display: "block", margin: "10px auto 0" }}
          />
        </div>
      </BaseOverlay>
    );
  }
}

export default VirtualPlayerOverlay;



// WEBPACK FOOTER //
// ./src/app/components/overlays/virtual-player.jsx